import { render, staticRenderFns } from "./viewException.vue?vue&type=template&id=70b062ee&scoped=true"
import script from "./viewException.vue?vue&type=script&lang=js"
export * from "./viewException.vue?vue&type=script&lang=js"
import style0 from "./viewException.vue?vue&type=style&index=0&id=70b062ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b062ee",
  null
  
)

export default component.exports